import { render } from "./HotLine.vue?vue&type=template&id=0d9695c8&scoped=true"
const script = {}

import "./HotLine.vue?vue&type=style&index=0&id=0d9695c8&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9695c8"]])

export default __exports__